import { useEffect as e } from "react";
const o = (t) => (
  // biome-ignore lint/correctness/useExhaustiveDependencies:
  e(() => () => t(), [])
);
export {
  o as useUnmountEffect
};
//# sourceMappingURL=useUnmountEffect.js.map
